import * as types from './mutation-types'
import * as CustomerTypes from './../customer/mutation-types'
export const loadData = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/funder/dashboard`, { params }).then((response) => {
            commit(types.SET_INITIAL_DATA, response.data)
            commit(types.SET_INVOICE_GROUP_COUNT, response.data.invoiceGroupCount)
            commit(types.GET_INITIAL_DATA, true)
            commit('customer/' + CustomerTypes.BOOTSTRAP_CUSTOMERS, response.data.customers, { root: true })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setKiborAmount = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/funder/kibor-amount`, params).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
